import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink, Info } from 'lucide-react';
import { expenseCategories } from '@vuokramani/shared';
import { Button, Dialog, DialogActions } from '../../components/ui.tsx';
import { CATEGORY_LINK, TAX_LINKS } from '../../lib/taxLinks.ts';
import s from './invoices.module.css';

/**
 * Huomautus talous- ja verosivuille: tarkista tiedot, Vuokrantti ei ole veroneuvoja.
 * Linkki avaa vähennysten selitykset ja Verohallinnon ohjeet.
 */
export function TaxNote() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className={s.taxNote}>
        <Info size={16} aria-hidden="true" />
        <p>
          {t('tax.disclaimer')}{' '}
          <button type="button" className={s.linkButton} onClick={() => setOpen(true)}>
            {t('tax.howDeductions')}
          </button>
        </p>
      </div>
      {open && <DeductionsGuide onClose={() => setOpen(false)} />}
    </>
  );
}

function DeductionsGuide({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();
  return (
    <Dialog open onClose={onClose} title={t('tax.guideTitle')} wide>
      <div className={s.guide}>
        <p>{t('tax.guideIntro')}</p>
        <dl>
          {expenseCategories.map((c) => (
            <div key={c}>
              <dt>{t(`expenses.category.${c}`)}</dt>
              <dd>
                {t(`tax.explain.${c}`)}{' '}
                <a href={CATEGORY_LINK[c]} target="_blank" rel="noreferrer">
                  {t('tax.readMore')}
                  <ExternalLink size={12} aria-hidden="true" />
                </a>
              </dd>
            </div>
          ))}
        </dl>
        <p className={s.meta}>
          {t('tax.guideLinks')}{' '}
          <a href={TAX_LINKS.rentalIncome} target="_blank" rel="noreferrer">
            {t('tax.linkRentalIncome')}
          </a>
          {' · '}
          <a href={TAX_LINKS.form7h} target="_blank" rel="noreferrer">
            {t('tax.link7h')}
          </a>
        </p>
        <p className={s.meta}>{t('tax.disclaimerLong')}</p>
      </div>
      <DialogActions>
        <Button variant="primary" onClick={onClose}>
          {t('common.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
